import { render, staticRenderFns } from "./sale-item.vue?vue&type=template&id=336eb2ca&"
import script from "./sale-item.vue?vue&type=script&lang=js&"
export * from "./sale-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports